import Vue from 'vue'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import Wechat from 'vue-wechat'
import ba from 'vue-ba'
Vue.use(ba, "1499ee81d42869bf3bff5578b85d918c");
Vue.use(ba, {
  siteId: "1499ee81d42869bf3bff5578b85d918c"
});
import {
  Collapse,
  CollapseItem,
  RadioGroup,
  Radio,
  NavBar,
  Button,
  Dialog,
  Col,
  Row,
  Icon
} from 'vant'

Vue.config.productionTip = false
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(NavBar)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Col)
Vue.use(Row)
Vue.use(Icon)
Vue.use(Wechat)
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')